import { useEffect, useRef, useState } from "react";
import { createNotificationConnection } from "../config/signalr.config";
import tokenService from "../services/tokenService";
import { notificationService } from "../services/notificationService";

export const useNotification = () => {
  const [unreadCount, setUnreadCount] = useState(0);
  const connectionRef = useRef(null);

  useEffect(() => {
    const userId = tokenService.getUserId();
    if (!userId) return;

    notificationService.getAllAsync({
      pageNumber: 1,
      pageSize: 1,
      isRead: false,
      includeDeleted: false,
    }).then((res) => {
      setUnreadCount(res?.totalCount ?? 0);
    }).catch(() => {});

    const conn = createNotificationConnection(userId);
    connectionRef.current = conn;

    const start = async () => {
      try {
        await conn.start();
        console.log("Notification SignalR connected");
      } catch (err) {
        console.error("Notification SignalR error:", err);
      }
    };

    start();

    conn.on("UnreadCount", (count) => {
      setUnreadCount(count);
    });

    return () => {
      conn.stop();
    };
  }, []);

  return { unreadCount };
};
